// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"801a52eb","774":"ec8d41e6"}[chunkId] + ".chunk.js";
};